import type { GroupState, MemberInfo } from "@psplit/ledger-core";

// One resolver for "which person does this id mean": claimed ghost ids on old
// entries resolve to the member who claimed them.
export function resolveMember(state: GroupState, pub: string): MemberInfo | undefined {
  const resolved = state.claims.get(pub) ?? pub;
  return state.members.find((m) => m.pubKey === resolved);
}

export function displayName(state: GroupState, pub: string): string {
  const resolved = state.claims.get(pub) ?? pub;
  const member = resolveMember(state, pub);
  return member && member.name !== "" ? member.name : resolved.slice(0, 8);
}
